import React from 'react';
import { ResponsiveProviderContextType } from './types';

export const Context = React.createContext<Partial<ResponsiveProviderContextType>>({});
